import { render, staticRenderFns } from "./detail.html?vue&type=template&id=53d91b68&scoped=true&external"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d91b68",
  null
  
)

export default component.exports